export default __webpack_public_path__ + "static/media/avtEmoji.de1867f5.svg";